import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Static asset helpers
export const GEN = {
  heroWide: "/generated/hero_wide.png",
  closeup: "/generated/closeup_portrait.png",
  actionLeap: "/generated/action_leap.png",
  villain: "/generated/villain_teaser.png",
};

export const MERCH_POSTER = "https://customer-assets-gfyr7b9c.emergentagent.net/job_naija-universe/artifacts/kia1kwbk_Gemini_Generated_Image_%20%2821%29.png";

export function formatNaira(amount) {
  return "\u20A6" + Number(amount || 0).toLocaleString("en-NG");
}

export const REFS = {
  ref1: "https://customer-assets-lqy194kg.emergentagent.net/job_98ce4f63-a77a-45ad-808c-168bf943ace9/artifacts/1lbgl2g2_A425A1A6-6C6F-4E4C-99EB-0E8207910FC4.PNG",
  ref2: "https://customer-assets-lqy194kg.emergentagent.net/job_98ce4f63-a77a-45ad-808c-168bf943ace9/artifacts/xo7z9cy4_IMG_1037.PNG",
  ref3: "https://customer-assets-lqy194kg.emergentagent.net/job_98ce4f63-a77a-45ad-808c-168bf943ace9/artifacts/rz9jlkpm_IMG_0672.PNG",
  ref4: "https://customer-assets-lqy194kg.emergentagent.net/job_98ce4f63-a77a-45ad-808c-168bf943ace9/artifacts/fco7csex_84247B62-267A-4AAC-8017-3437CE4E368F.PNG",
  ref5: "https://customer-assets-lqy194kg.emergentagent.net/job_98ce4f63-a77a-45ad-808c-168bf943ace9/artifacts/vh0kw8mg_IMG_0922.PNG",
};
